import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class MyObserverService {
    styleModel = new Subject<string>();
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/myobject.service.ts